import { render, staticRenderFns } from "./profileTabs.vue?vue&type=template&id=b9ddd16a&scoped=true"
import script from "./profileTabs.vue?vue&type=script&lang=js"
export * from "./profileTabs.vue?vue&type=script&lang=js"
import style0 from "./profileTabs.vue?vue&type=style&index=0&id=b9ddd16a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ddd16a",
  null
  
)

export default component.exports